import Vue from 'vue'
import VueRouter from 'vue-router'
import Other from './Other.js'
import Power from './Power.js'
import Product from './Product.js'
import Img from './Img.js'

Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
    ...Other,
    ...Power,
    ...Product,
    ...Img,
]

const router = new VueRouter({
  routes
})

export default router
